export default "__VITE_ASSET__d0cbf1d3__"